import * as mutations from './types/mutations';
import { chapterMapper, chaptersMapper } from "./normalizer";
import {syncMapper} from "../Sync/normalizer";

export default {
    [mutations.SET_ARTISTS]: (state, artists) => {
        state.artists = chapterMapper(artists);
    },
    [mutations.SET_CHAPTER]: (state, chapter) => {
        state.chapter = chapterMapper(chapter);
    },
    [mutations.SET_CHAPTERS]: (state, chapters) => {
        state.chapters = chaptersMapper(chapters);
    },
    [mutations.SET_SYNC_FOR_CURRENT_CHAPTER]: (state, newSync) => {
        state.chapters[newSync.chapterId].sync = {
            ...state.chapters[newSync.chapterId].sync,
            [newSync.id]: syncMapper(newSync)
        };
    },
    [mutations.UPDATE_SYNC_FOR_CURRENT_CHAPTER]: (state, updateSync) => {
        state.chapters[updateSync.chapterId].sync[updateSync.id] = syncMapper(updateSync);
        state.chapters[updateSync.chapterId].sync = {
            ...state.chapters[updateSync.chapterId].sync
        };
    },
    [mutations.DELETE_SYNC_FOR_CURRENT_CHAPTER]: (state, deleteSync) => {
        delete state.chapters[deleteSync.chapterId].sync[deleteSync.id];
        state.chapters[deleteSync.chapterId].sync = {
            ...state.chapters[deleteSync.chapterId].sync
        };
    },
    [mutations.DELETE_CHAPTER]: (state, deleteChapterId) => {
        delete state.chapters[deleteChapterId];
        state.chapter = {}
        state.chapters = {
            ...state.chapters
        }
    },
    [mutations.ADD_CHAPTER]: (state, chapter) => {
        state.chapters = {
            ...state.chapters,
            [chapter.id]: chapterMapper(chapter)
        };
    }
};
